import React, { useEffect, useState } from "react";
import { imgClients } from "../../../assets/activityes/activityFour";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { audiosAssets } from "../../../assets/audio";

const clinetsInfo = [
	{
		id: 1,
		textQuestion: "Necesito pagar este artículo rápido, tengo prisa.",
		img: imgClients.torsoApurado,
		responseone: {
			text: "Descuidar los procesos establecidos con el objetivo de atender rápidamente al cliente.",
			isCorrect: true,
			id: 1,
		},
		responseTwo: {
			text: "Mantener la calma y la eficiencia para agilizar el proceso de atención.",
			isCorrect: false,
			id: 2,
		},
	},
	{
		id: 2,
		textQuestion: "No aceptaré nada más que un reembolso completo.",
		img: imgClients.torsoTerco,
		responseone: {
			text: "Explicar las razones y motivos de manera clara y respetuosa, cuantas veces sea necesario.",
			isCorrect: true,
			id: 1,
		},
		responseTwo: {
			text: "Ceder a todas las demandas del cliente sin considerar las políticas o restricciones.",
			isCorrect: false,
			id: 2,
		},
	},
	{
		id: 3,
		textQuestion: "¡Otra vez tengo problemas con la mercancía en esta tienda! Siempre hay productos vencidos o en mal estado.",
		img: imgClients.torsoQuejoso,
		responseone: {
			text: "Escuchar atentamente al cliente y permitir que se desahogue.",
			isCorrect: true,
			id: 1,
		},
		responseTwo: {
			text: "Descalificar o minimizar las preocupaciones del cliente.",
			isCorrect: false,
			id: 2,
		},
	},
	{
		id: 4,
		textQuestion: "¡Siempre tienen los estantes desordenados y nunca encuentro lo que necesito!",
		img: imgClients.torsoEnojon,
		responseone: {
			text: "Mantener una actitud amable y profesional, incluso si el cliente está enojado.",
			isCorrect: true,
			id: 1,
		},
		responseTwo: {
			text: "Negar cualquier responsabilidad o solución al problema planteado por el cliente.",
			isCorrect: false,
			id: 2,
		},
	},
	{
		id: 5,
		textQuestion: "Oye, no puedo creer la ineficiencia de este lugar. Todo está desorganizado y el servicio es una porquería.",
		img: imgClients.torsoGrosero,
		responseone: {
			text: "Tratar al cliente grosero de manera cortés y profesional, sin mostrar preferencia o trato especial.",
			isCorrect: true,
			id: 1,
		},
		responseTwo: {
			text: "Ignorar las necesidades o inquietudes del cliente y no ofrecer soluciones.",
			isCorrect: false,
			id: 2,
		},
	},
	{
		id: 6,
		textQuestion: "Estoy buscando unas galletas, pero no logro encontrarlas. No sé muy bien cómo funciona este lugar.",
		img: imgClients.torsoMayor,
		responseone: {
			text: "Mostrar paciencia y comprensión hacia el cliente adulto mayor.",
			isCorrect: true,
			id: 1,
		},
		responseTwo: {
			text: "No ofrecer asistencia adicional cuando sea necesario.",
			isCorrect: false,
			id: 2,
		},
	},
	{
		id: 7,
		textQuestion: "Hola, quiero comprar algo con mi dinero, pero no sé qué elegir.",
		img: imgClients.torsoNino,
		responseone: {
			text: "Ayudar al niño a tomar decisiones ofreciéndole opciones y explicándole las características de los productos.",
			isCorrect: true,
			id: 1,
		},
		responseTwo: {
			text: "No prestar atención a las preocupaciones o preguntas del niño.",
			isCorrect: false,
			id: 2,
		},
	},
	{
		id: 8,
		textQuestion: "¡No me digas qué hacer, solo dame las cervezas!",
		img: imgClients.torsoAlcholizado,
		responseone: {
			text: "Monitorear situación y, si cliente se vuelve agresivo, buscar ayuda autoridades, asesor o centro de control.",
			isCorrect: true,
			id: 1,
		},
		responseTwo: {
			text: "Intentar manejar situación sin buscar ayuda adecuada si cliente se vuelve agresivo.",
			isCorrect: false,
			id: 2,
		},
	},
	{
		id: 9,
		textQuestion: "Estoy buscando algo para tomar, pero no sé qué elegir.",
		img: imgClients.torsoIndeciso,
		responseone: {
			text: "Saludar al cliente y ofrecer ayuda de manera amigable.",
			isCorrect: true,
			id: 1,
		},
		responseTwo: {
			text: "Presionar al cliente para que tome una decisión rápidamente o elija un producto específico.",
			isCorrect: false,
			id: 2,
		},
	},
];

const randomArrayQuestionsActive = clinetsInfo.sort(() => Math.random() - 0.5);

// Aplicar la función a cada elemento del arreglo modificado
const randomResponse = randomArrayQuestionsActive.map((ran) => {
	let responses = {
		one: ran.responseone,
		two: ran.responseTwo
	}
	const shouldSwap = Math.random() < 0.5;
	if (shouldSwap) {
		responses = {
			one: ran.responseTwo,
			two: ran.responseone
		}
	}
	return {
		...ran,
		responseone: responses.one,
		responseTwo: responses.two
	}
})

const randomArrayQuestions = randomResponse

export const GameTwoActovityFour = ({ calllbackWin }) => {
	const [actualQuestion, setActualQuestion] = useState(0);
	const [points, setPoints] = useState(0);
	const [isNextQuestion, setIsNextQuestion] = useState(false)
	const [selectIdResponse, setSelectIdResponse] = useState(0)
	const [statusResponse, setStatusResponse] = useState(0)

	const nextQuestion = () => {
		if (actualQuestion < 2) {
			setActualQuestion(actualQuestion + 1);
		} else {
			calllbackWin(points);
		}
		setSelectIdResponse(0)
		setStatusResponse(0)
		setIsNextQuestion(false)
	}

	const evaluateResponse = (question, idQuestion = 0) => {
		if (isNextQuestion) {
			return
		}

		if (question.isCorrect) {
			setPoints(points + 1);
		}
		setStatusResponse(question.isCorrect ? 1 : 2)
		setSelectIdResponse(idQuestion)
		setIsNextQuestion(!isNextQuestion)
	};

	useEffect(() => {
		let time = null
		if (isNextQuestion) {
			setTimeout(() => {
				nextQuestion()
			}, 1000);
		}
		return () => {
			clearTimeout(time)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isNextQuestion])


	return (
		<>
			{/* h-[60px] md:w-52 md:h-[65px] + 20px*/}
			<div className="fixed z-20 w-full h-full bottom-0 animate__animated  animate__fadeIn">
				<div className="h-full w-full">
					<div className="w-full h-[calc(100%-100px)] md:h-[calc(100%-200px)] flex justify-center items-end">
						<div className="h-[200px] md:h-[500px] w-full">
							<img className="h-full w-full object-contain" src={randomArrayQuestions[actualQuestion].img} alt="client" />
						</div>
					</div>
					<div className="w-full h-[100px] md:h-[200px] px-10 pb-1 md:pb-6">
						<div className="h-full w-full gradiantBlueClient rounded-3xl p-2">
							<div className="w-full h-[24px] md:h-[40px] bg-red_primary rounded-tl-3xl rounded-tr-3xl flex justify-center items-center mb-1 md:mb-4">
								<p className="text-white text-[14px] md:text-[16px] md:font-semibold">Selecciona la respuesta correcta.</p>
							</div>
							<div className="h-[calc(100%-24px)] md:h-[calc(100%-60px)] w-full flex gap-2">
								<ResponseQuestion
									id={1}
									selectResponse={selectIdResponse}
									typeResponse={statusResponse}
									isLetterA={true}
									text={randomArrayQuestions[actualQuestion].responseone.text}
									action={() => {
										evaluateResponse(randomArrayQuestions[actualQuestion].responseone, 1);
									}}
								/>
								<ResponseQuestion
									id={2}
									selectResponse={selectIdResponse}
									typeResponse={statusResponse}
									text={randomArrayQuestions[actualQuestion].responseTwo.text}
									action={() => {
										evaluateResponse(randomArrayQuestions[actualQuestion].responseTwo, 2);
									}}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

const ResponseQuestion = ({ id = 0, selectResponse = 0, isLetterA = false, text = "", action = () => { }, typeResponse = 0 }) => {
	let styleQuestion = { back: "bg-white", colorText: "text-black", colorLetter: "text-red_primary" }

	if (typeResponse === 1 && id === selectResponse) {
		styleQuestion = { back: "bg-[#22C55E]", colorText: "text-white", colorLetter: "text-white" }
	}
	if (typeResponse === 2 && id === selectResponse) {
		styleQuestion = { back: "bg-[#DF3C3C]", colorText: "text-white", colorLetter: "text-white" }
	}
	return (
		<div onClick={() => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.completeNavigation)
			action()
		}} className={`${styleQuestion.back} w-full rounded-2xl flex items-center p-2 md:gap-4`}>
			<div className="w-[20px] ">
				<p className={`${styleQuestion.colorLetter} font-bold text-[12px] md:text-[20px]`}>{isLetterA ? "a)" : "b)"}</p>
			</div>
			<div className="w-[cacl(100%-20px)] overflow-hidden">
				<p className={`${styleQuestion.colorText} text-[10px] md:text-[14px]`}>{text}</p>
			</div>
		</div>
	);
};
